import readFutureEntrate from './readFutureEntrate';
import readFuturePatrimonio from './readFuturePatrimonio';
import readFutureUscite from './readFutureUscite';

export default async function readFuture(username, token, typeOfFuture, dataIniziale, dataFinale) {
    return new Promise(function (resolve, reject) {
        switch (typeOfFuture) {
            case "patrimonio":
                readFuturePatrimonio(username, token, dataIniziale, dataFinale).then(r => resolve(r)).catch(e => console.error(e));
                break;
            case "uscite":
                readFutureUscite(username, token, dataIniziale, dataFinale).then(r => resolve(r)).catch(e => console.error(e));
                break;
            case "entrate": 
                readFutureEntrate(username, token, dataIniziale, dataFinale).then(r => resolve(r)).catch(e => console.error(e));
                break;
            default:
                break;
        }
    });
}
